export default __webpack_public_path__ + "static/media/bernay3.2a8399a0.jpg";